import type {
	GroupedParametrics,
	ParametricListValue,
	Product
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import { activeStatusID } from "~/utils/constants";

/**
 * Remove colors whose every matching variant is inactive (StatusId !== activeStatusID).
 * Colors without any matching variant are kept untouched.
 */
export const filterInactiveColorParametrics = ({
	parametrics,
	products
}: {
	parametrics: GroupedParametrics;
	products: Product;
}): ParametricListValue[] => {
	const colors = parametrics?.color ?? [];
	const variants = products?.Variants ?? [];
	if (!colors.length || !variants.length) return colors;

	return colors.filter((color) => {
		const variantsForColor = variants.filter((variant) =>
			variant.VariantParametrics?.some((p) => p.ValueId === color.Id)
		);
		if (!variantsForColor.length) return true;
		return variantsForColor.some((v) => v.StatusId === activeStatusID);
	});
};
